import { xlCol, xlColq } from "../../../common/constants"
import moment from 'moment'
import { getStaOperatorHamaliLabel, getStaOptHamaliGstLabel, isStaCompany } from '../../../common/helper'

export const withStaDispatchColumns = (columns, companyId) => {
  if (!isStaCompany(companyId)) return columns
  return columns.map((col) => {
    if (col.field === 'OperatorHamaliChg') {
      const compact = [col.header, col.pdfHead, col.headerName].some(
        (v) => typeof v === 'string' && v.includes('\n')
      )
      const label = getStaOperatorHamaliLabel(compact)
      const exportLabel = getStaOperatorHamaliLabel(false)
      return {
        ...col,
        ...(col.header != null ? { header: label } : {}),
        ...(col.pdfHead != null ? { pdfHead: label } : {}),
        ...(col.headerName != null ? { headerName: exportLabel } : {}),
        ...(col.exportHead != null ? { exportHead: exportLabel } : {}),
      }
    }
    if (col.field === 'OptHamaliGST') {
      const compact = [col.header, col.pdfHead, col.headerName].some(
        (v) => typeof v === 'string' && v.includes('\n')
      )
      const label = getStaOptHamaliGstLabel(compact)
      const exportLabel = getStaOptHamaliGstLabel(false)
      return {
        ...col,
        ...(col.header != null ? { header: label } : {}),
        ...(col.pdfHead != null ? { pdfHead: label } : {}),
        ...(col.headerName != null ? { headerName: exportLabel } : {}),
        ...(col.exportHead != null ? { exportHead: exportLabel } : {}),
      }
    }
    return col
  })
}

export const partyAs = [
  { id: 0, name: 'Any' },
  { id: 1, name: 'Sender' },
  { id: 2, name: 'Receiver' },
  { id: 3, name: 'Payment Responsibility' },
]
export const partyAll = {
  Party: `All`,
  PartyID: 0,
}
export const summerFilter = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Paymentwise Summary' },
  { id: 2, name: 'Booking City Wise' },
  { id: 3, name: 'Booking Branch Wise' },
  { id: 4, name: 'Destination Branch Wise' },
  { id: 5, name: 'Destination City Wise' },
  { id: 6, name: 'Summary Cancelled Dispatch' },
]
export const payType = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Cash' },
  { id: 2, name: 'Credit' },
]
export const bookingTypeDropdown = [
  { id: 0, name: 'Online And Offline' },
  { id: 1, name: 'Online' },
  { id: 2, name: 'Offline' },
]

const coloumnDispatchDetails11Columns = [
  { isHeader: true, header: 'Detailed Table', weight: 0 },
  {
    header: 'SN',
    pdfHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 50,
    headerSx: {
      minWidth: '50px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 0,
  },
  {
    header: 'LR No.\nMan. LR No.',
    pdfHead: 'LR No.\nMan. LR No.',
    field: 'CombinedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Chl. No.\nBill No.',
    pdfHead: 'Chl. No.\nBill No.',
    field: 'VoucherNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Disp. Date\nDisp. Time',
    pdfHead: 'Disp. Date\nDisp. Time',
    field: 'DispTimeAndDate',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'Book. Date\nBook. Time',
    pdfHead: 'Book. Date\nBook. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 4,
  },
  {
    header: 'Src. City \nSrc. Br.',
    pdfHead: 'Src. City \nSrc. Br.',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'Dest. City \nDest. Br.',
    pdfHead: 'Dest. City \nDest. Br.',
    field: 'DestCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 41,
  },
  {
    header: 'Disp. City \nDisp. Br.',
    pdfHead: 'Disp. City \nDisp. Br.',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 6,
  },
  {
    header: 'Pkp. City \nPkp. Branch',
    pdfHead: 'Pkp. City \nPkp. Branch',
    field: 'PickupCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'Sender \nDetails',
    pdfHead: 'Sender \nDetails',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, maxCellWidth: 120, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'Receiver \nDetails',
    pdfHead: 'Receiver \nDetails',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'Item\nType',
    pdfHead: 'Item\nType',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'Pymt.\nType',
    pdfHead: 'Pymt.\nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'Veh.\nNo.',
    pdfHead: 'Veh.\nNo.',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'VehicleNo',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 11,
  },
  // {
  //   header: 'Veh\nNo.',
  //   pdfHead: 'Veh\nNo.',
  //   xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
  //   field: 'VehicleNo',
  //   headerSx: { minWidth: '120px', textAlign: 'left' },
  //   Align: 'left',

  //   pdfColSx: {
  //     fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
  //   },
  //   isSummaryHeader: false,
  //   allowSorting: false,
  //   isSelected: true,
  //   isDefault: false,
  //   isMandatory: false,
  //   id: 40,
  // },
  {
    header: 'QTY.',
    pdfHead: 'Qty.',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 45,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'Freight',
    pdfHead: 'Frgt.\nchrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 13,
  },
  {
    header: 'Doc. \nCharge',
    pdfHead: 'Doc.\nChrg.',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 14,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'Ham.',
    pdfHead: 'Ham.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'Op. \nHamali',
    pdfHead: 'Op.\nHamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 17,
  },
  {
    header: 'Frt.\n GST',
    pdfHead: 'Frt.\n GST',
    field: 'ServiceTaxAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 18,
  },
  {
    header: 'Cart.\n GST',
    pdfHead: 'Cart.\n GST',
    field: 'CartageTax',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 19,
  },
  {
    header: 'Ham+Op.\n Ham GST',
    pdfHead: 'Ham+Op.\nHam. GST',
    field: 'OptHamaliGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 20,
  },
  {
    header: 'Val.\n Chrg.',
    pdfHead: 'Val.\n Chrg.',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 21,
  },
  {
    header: 'Oth.\n Chrg.',
    pdfHead: 'Oth.\n Chrg.',
    field: 'AllOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 22,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 23,
  },
  { isHeader: true, header: 'Summary Table', weight: 0 },
  {
    header: 'Payment Type',
    pdfHead: 'Payment Type',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',
    pdfColSx: {
      fontSize: 16, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'left'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 24,
  },
  {
    header: 'Item Type (Quantity)',
    pdfHead: 'Item Type (Quantity)',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 25,
  },
  {
    header: 'Freight',
    pdfHead: 'Freight',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 26,
  },
  {
    header: 'Doc Charge',
    pdfHead: 'Doc Charge',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 27,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 28,
  },
  {
    header: 'Hamali',
    pdfHead: 'Hamali',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 29,
  },
  {
    header: 'Operator Hamali',
    pdfHead: 'Operator Hamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 30,
  },
  {
    header: 'Freight GST',
    pdfHead: 'Freight GST',
    field: 'ServiceTaxAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 31,
  },
  {
    header: 'Cartage GST',
    pdfHead: 'Cartage GST',
    field: 'CartageTax',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 32,
  },
  {
    header: 'Hamali + Op.Hamali GST',
    pdfHead: 'Hamali + Op.Hamali GST',
    field: 'OptHamaliGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 33,
  },
  {
    header: 'Valuation Charge',
    pdfHead: 'Valuation Charge',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 34,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 35,
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 65,
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    Align: 'left',
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 36,
  },

];

export const coloumnDispatchDetails11 = (companyId) =>
  withStaDispatchColumns(coloumnDispatchDetails11Columns, companyId)

const coloumnDispatchDetails12Columns = [
  { isHeader: true, header: 'Detailed Table', weight: 0 },
  {
    header: 'SN',
    pdfHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 50,
    headerSx: {
      minWidth: '50px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 0,
  },
  {
    header: 'LR No.\nMan. LR No.',
    pdfHead: 'LR No.\nMan. LR No.',
    field: 'OnlyLRNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Chl. No.\nBill No.',
    pdfHead: 'Chl. No.\nBill No.',
    field: 'VoucherNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Disp. Date\nDisp. Time',
    pdfHead: 'Disp. Date\nDisp. Time',
    field: 'DispTimeAndDate',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'Book. Date\nBook. Time',
    pdfHead: 'Book. Date\nBook. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 4,
  },
  {
    header: 'Src. City \nSrc. Br.',
    pdfHead: 'Src. City \nSrc. Br.',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'Dest. City \nDest. Br.',
    pdfHead: 'Dest. City \nDest. Br.',
    field: 'DestCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 41,
  },
  {
    header: 'Disp. City \nDisp. Br.',
    pdfHead: 'Disp. City \nDisp. Br.',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 6,
  },
  {
    header: 'Pkp. City \nPkp. Branch',
    pdfHead: 'Pkp. City \nPkp. Branch',
    field: 'PickupCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'Sender \nDetails',
    pdfHead: 'Sender \nDetails',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, maxCellWidth: 120, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'Receiver \nDetails',
    pdfHead: 'Receiver \nDetails',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'Item\nType',
    pdfHead: 'Item\nType',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'Pymt.\nType',
    pdfHead: 'Pymt.\nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 11,
  },
  {
    header: 'Veh.\nNo.',
    pdfHead: 'Veh.\nNo.',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'VehicleNo',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'QTY.',
    pdfHead: 'Qty.',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 45,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'Freight',
    pdfHead: 'Frgt.\nchrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 13,
  },
  {
    header: 'Doc. \nCharge',
    pdfHead: 'Doc.\nChrg.',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 14,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'Ham.',
    pdfHead: 'Ham.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'Op. \nHamali',
    pdfHead: 'Op.\nHamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 17,
  },
  {
    header: 'Val.\n Chrg.',
    pdfHead: 'Val.\n Chrg.',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 21,
  },
  {
    header: 'Oth.\n Chrg.',
    pdfHead: 'Oth.\n Chrg.',
    field: 'AllOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 22,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 23,
  },
  { isHeader: true, header: 'Summary Table', weight: 0 },
  {
    header: 'Payment Type',
    pdfHead: 'Payment Type',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',
    pdfColSx: {
      fontSize: 16, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'left'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 24,
  },
  {
    header: 'Item Type (Quantity)',
    pdfHead: 'Item Type (Quantity)',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 25,
  },
  {
    header: 'Freight',
    pdfHead: 'Freight',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 26,
  },
  {
    header: 'Doc Charge',
    pdfHead: 'Doc Charge',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 27,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 28,
  },
  {
    header: 'Hamali',
    pdfHead: 'Hamali',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 29,
  },
  {
    header: 'Operator Hamali',
    pdfHead: 'Operator Hamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 30,
  },
  {
    header: 'Valuation Charge',
    pdfHead: 'Valuation Charge',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 34,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 35,
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 65,
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    Align: 'left',
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 36,
  },
];

export const coloumnDispatchDetails12 = (companyId) =>
  withStaDispatchColumns(coloumnDispatchDetails12Columns, companyId)


const coloumnDispatchDetails1WithFormatLRColumns = [
  { isHeader: true, header: 'Detailed Table', weight: 0 },
  {
    header: 'SN',
    pdfHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 50,
    headerSx: {
      minWidth: '50px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 0,
  },
  {
    header: 'LR No.\nMan. LR No.',
    pdfHead: 'LR No.\nMan. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Formatted LR No',
    pdfHead: 'Formatted LR No',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 85,
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Chl. No.\nBill No.',
    pdfHead: 'Chl. No.\nBill No.',
    field: 'VoucherNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'Disp. Date\nDisp. Time',
    pdfHead: 'Disp. Date\nDisp. Time',
    field: 'DispTimeAndDate',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 4,
  },
  {
    header: 'Book. Date\nBook. Time',
    pdfHead: 'Book. Date\nBook. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 5,
  },
  {
    header: 'Src. City \nSrc. Br.',
    pdfHead: 'Src. City \nSrc. Br.',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'Dest. City \nDest. Br.',
    pdfHead: 'Dest. City \nDest. Br.',
    field: 'DestCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 41,
  },
  {
    header: 'Disp. City \nDisp. Br.',
    pdfHead: 'Disp. City \nDisp. Br.',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'Pkp. City \nPkp. Branch',
    pdfHead: 'Pkp. City \nPkp. Branch',
    field: 'PickupCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'Sender \nDetails',
    pdfHead: 'Sender \nDetails',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, maxCellWidth: 120, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'Receiver \nDetails',
    pdfHead: 'Receiver \nDetails',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'Item\nType',
    pdfHead: 'Item\nType',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 11,
  },
  {
    header: 'Pymt.\nType',
    pdfHead: 'Pymt.\nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'Veh\nNo.',
    pdfHead: 'Veh\nNo.',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'VehicleNo',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'QTY.',
    pdfHead: 'Qty.',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 45,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 13,
  },
  {
    header: 'Freight',
    pdfHead: 'Frgt.\nchrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 14,
  },
  {
    header: 'Doc. \nCharge',
    pdfHead: 'Doc.\nChrg.',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'Ham.',
    pdfHead: 'Ham.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 17,
  },
  {
    header: 'Op. \nHamali',
    pdfHead: 'Op.\nHamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 18,
  },
  {
    header: 'Frt.\n GST',
    pdfHead: 'Frt.\n GST',
    field: 'ServiceTaxAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 19,
  },
  {
    header: 'Cart.\n GST',
    pdfHead: 'Cart.\n GST',
    field: 'CartageTax',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 20,
  },
  {
    header: 'Ham+Op.\n Ham GST',
    pdfHead: 'Ham+Op.\nHam. GST',
    field: 'OptHamaliGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 21,
  },
  {
    header: 'Val.\n Chrg.',
    pdfHead: 'Val.\n Chrg.',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 22,
  },
  {
    header: 'Oth.\n Chrg.',
    pdfHead: 'Oth.\n Chrg.',
    field: 'AllOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 23,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 24,
  },
  { isHeader: true, header: 'Summary Table', weight: 0 },
  {
    header: 'Payment Type',
    pdfHead: 'Payment Type',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',
    pdfColSx: {
      fontSize: 16, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'left'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 25,
  },
  {
    header: 'Item Type (Quantity)',
    pdfHead: 'Item Type (Quantity)',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 26,
  },
  {
    header: 'Freight',
    pdfHead: 'Freight',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 27,
  },
  {
    header: 'Doc Charge',
    pdfHead: 'Doc Charge',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 28,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 29,
  },
  {
    header: 'Hamali',
    pdfHead: 'Hamali',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 30,
  },
  {
    header: 'Operator Hamali',
    pdfHead: 'Operator Hamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 31,
  },
  {
    header: 'Freight GST',
    pdfHead: 'Freight GST',
    field: 'ServiceTaxAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 32,
  },
  {
    header: 'Cartage GST',
    pdfHead: 'Cartage GST',
    field: 'CartageTax',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 33,
  },
  {
    header: 'Hamali + Op.Hamali GST',
    pdfHead: 'Hamali + Op.Hamali GST',
    field: 'OptHamaliGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 34,
  },
  {
    header: 'Valuation Charge',
    pdfHead: 'Valuation Charge',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 35,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 36,
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 65,
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    Align: 'left',
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 36,
  },

];

export const coloumnDispatchDetails1WithFormatLR = (companyId) =>
  withStaDispatchColumns(coloumnDispatchDetails1WithFormatLRColumns, companyId)

const coloumnDispatchDetailsForExcelColumns = [
  {
    header: 'Serial Number',
    pdfHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'LR Number',
    pdfHead: 'LR No.',
    field: 'OnlyLRNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'Manual LR Number',
    pdfHead: 'Man. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'Formatted LR Number',
    pdfHead: 'Formatted LR No',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 50,
  },
  {
    header: 'Challan Number',
    pdfHead: 'Chl. No.',
    field: 'VoucherNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 2,
  },
  {
    header: 'Bill Number',
    pdfHead: 'Bill No.',
    field: 'VoucherNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 2,
  },
  // {
  //   header: 'Disp. Date Disp. Time',
  //   pdfHead: 'Disp. Date Disp. Time',
  //   field: 'DispTimeAndDate',
  //   xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
  //   headerSx: { width: '50%', textAlign: 'left' },
  //   Align: 'left',
  //   allowSorting: true,
  //   isSelected: true,
  //   isMandatory: true,
  //   id: 3,
  // },
  {
    header: 'Dispatch Date Time',
    pdfHead: 'Disp. Date Time',
    field: 'DispTimeAndDate',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 3,
  },
  {
    header: 'Booking Date Time',
    pdfHead: 'Book. Date Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 3,
  },
  // {
  //   header: 'Book. Time',
  //   pdfHead: 'Book. Time',
  //   field: 'BookingDateTime',
  //   xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
  //   headerSx: { width: '50%', textAlign: 'left' },
  //   Align: 'left',
  //   allowSorting: true,
  //   isSelected: true,
  //   isMandatory: true,
  //   id: 3,
  // },
  {
    header: 'Source City',
    pdfHead: 'Src. City',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },
  {
    header: 'Source Branch',
    pdfHead: 'Src. Branch',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },
  {
    header: 'Destination City',
    pdfHead: 'Dest. City',
    field: 'DestCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },
  {
    header: 'Destination Branch',
    pdfHead: 'Dest. Branch',
    field: 'DestCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },
  {
    header: 'Dispatch City',
    pdfHead: 'Disp. City',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'left',
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 6,
  },
  {
    header: 'Dispatch Branch',
    pdfHead: 'Disp. Br.',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'left',
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 6,
  },
  {
    header: 'Pickup City',
    pdfHead: 'Pkp. City',
    field: 'PickupCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    id: 8,
  },
  {
    header: 'Pickup Branch',
    pdfHead: 'Pkp. Branch',
    field: 'PickupCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    id: 8,
  },
  {
    header: 'Sender Name',
    pdfHead: 'Sender Name',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Sender GSTIN',
    pdfHead: 'Sender GSTIN',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Sender Mobile Number',
    pdfHead: 'Sender MoNo',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Sender Email',
    pdfHead: 'Sender Email',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 10,
  },
  {
    header: 'Receiver Name',
    pdfHead: 'Receiver Name',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Receiver GSTIN',
    pdfHead: 'Receiver GSTIN',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Receiver Mobile Number',
    pdfHead: 'Receiver MoNo',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Receiver Email',
    pdfHead: 'Receiver Email',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 10,
  },
  {
    header: 'Item\n Type',
    pdfHead: 'Item\n Type',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 11,
  },
  {
    header: 'Payment \nType',
    pdfHead: 'Pymt. \nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'left',
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 12,
  },
  {
    header: 'Quantity',
    pdfHead: 'Qty.',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    Align: 'right',
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 13,
  },
  {
    header: 'Freight',
    pdfHead: 'Frgt.\nchrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 14,
  },
  {
    header: 'Document \nCharge',
    pdfHead: 'Doc.\nChrg.',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 15,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 16,
  },
  {
    header: 'Hamali',
    pdfHead: 'Ham.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 17,
  },
  {
    header: 'Operator \nHamali',
    pdfHead: 'Op.\nHamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 18,
  },
  {
    header: 'Freight\n GST',
    pdfHead: 'Frt.\n GST',
    field: 'ServiceTaxAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 19,
  },
  {
    header: 'Cartage\n GST',
    pdfHead: 'Cart.\n GST',
    field: 'CartageTax',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 20,
  },
  {
    header: 'Hamali+Operator\n Hamali GST',
    pdfHead: 'Ham+Op.\nHam. GST',
    field: 'OptHamaliGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 21,
  },
  {
    header: 'Valuation\n Charge',
    pdfHead: 'Val.\n Chrg.',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 22,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    Align: 'right',
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 23,
  },
];
export const coloumnDispatchDetailsForExcel = (companyId) =>
  withStaDispatchColumns(coloumnDispatchDetailsForExcelColumns, companyId)

export const coloumnDispatchDetailsForExcel2 = (companyId) => [
  ...coloumnDispatchDetailsForExcel(companyId),
  {
    header: 'Cancelled\nBy User',
    pdfHead: 'Cancelled \nBy User',
    field: 'CancelledByUser',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    allowSorting: true,
    isSummaryHeader: false,
    isSelected: true,
    isMandatory: true,
    id: 36,
  },
  {
    header: 'Logged in\nUser',
    pdfHead: 'Logged in \nUser',
    field: 'CancelledByBaseUser',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    allowSorting: true,
    isSummaryHeader: false,
    isSelected: true,
    isMandatory: true,
    id: 38,
  },
  {
    header: 'Dispatch\nDate & Time',
    pdfHead: 'Dispatch \nDate & Time',
    field: 'CancelledDate',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    allowSorting: true,
    isSummaryHeader: false,
    isSelected: true,
    isMandatory: true,
    id: 37,
  },
]

export const coloumnDispatchDetails2 = (companyId) =>
  withStaDispatchColumns(coloumnDispatchDetails2Columns, companyId)

const coloumnDispatchDetails2Columns = [
  { isHeader: true, header: 'Detailed Table', weight: 0 },
  {
    header: 'SN',
    pdfHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 50,
    headerSx: {
      minWidth: '50px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 0,
  },
  {
    header: 'LR No.\nMan. LR No.',
    pdfHead: 'LR No.\nMan. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Chl. No.\nBill No.',
    pdfHead: 'Chl. No.\nBill No.',
    field: 'VoucherNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: {
      minWidth: '80px', textAlign: 'left'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Disp. Date\nDisp. Time',
    pdfHead: 'Disp. Date\nDisp. Time',
    field: 'DispTimeAndDate',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'Src. City \nSrc. Br.',
    pdfHead: 'Src. City \nSrc. Br.',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'Dest. City \nDest. Br.',
    pdfHead: 'Dest. City \nDest. Br.',
    field: 'DestCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 41,
  },
  {
    header: 'Disp. City \nDisp. Br.',
    pdfHead: 'Disp. City \nDisp. Br.',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 5,
  },
  {
    header: 'Pkp. City \nPkp. Branch',
    pdfHead: 'Pkp. City \nPkp. Branch',
    field: 'PickupCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 6,
  },
  {
    header: 'Sender \nDetails',
    pdfHead: 'Sender \nDetails',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'Receiver \nDetails',
    pdfHead: 'Receiver \nDetails',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 100,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'Item\n Type',
    pdfHead: 'Item\n Type',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: true,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'Pymt. \nType',
    pdfHead: 'Pymt. \nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'Veh.\nNo.',
    pdfHead: 'Veh.\nNo.',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'VehicleNo',
    weight: 60,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 40,
  },
  {
    header: 'QTY.',
    pdfHead: 'Qty.',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 45,
    headerSx: { minWidth: '80px', textAlign: 'left' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 11,
  },
  {
    header: 'Freight',
    pdfHead: 'Frgt.\nchrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'Doc. \nCharge',
    pdfHead: 'Doc.\nChrg.',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'Ham.',
    pdfHead: 'Ham.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 17,
  },
  {
    header: 'Op. \nHamali',
    pdfHead: 'Op.\nHamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 18,
  },
  {
    header: 'Frt.\n GST',
    pdfHead: 'Frt.\n GST',
    field: 'ServiceTaxAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 19,
  },
  {
    header: 'Cart.\n GST',
    pdfHead: 'Cart.\n GST',
    field: 'CartageTax',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 20,
  },
  {
    header: 'Ham+Op.\n Ham GST',
    pdfHead: 'Ham+Op.\nHam. GST',
    field: 'OptHamaliGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 110, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 21,
  },
  {
    header: 'Val.\n Chrg.',
    pdfHead: 'Val.\n Chrg.',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 22,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '80px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
    isSummaryHeader: false,
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 23,
  },

  {
    header: 'Cancelled\nBy User',
    pdfHead: 'Cancelled \nBy User',
    field: 'CancelledByUser',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 100,
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    allowSorting: true,
    isSummaryHeader: false,
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
    id: 36,
  },
  {
    header: 'Logged in\nUser',
    pdfHead: 'Logged in \nUser',
    field: 'CancelledByBaseUser',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 100,
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    allowSorting: true,
    isSummaryHeader: false,
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
    id: 38,
  },
  {
    header: 'Dispatch\nDate & Time',
    pdfHead: 'Dispatch \nDate & Time',
    field: 'CancelledDate',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 125, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    allowSorting: true,
    isSummaryHeader: false,
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
    id: 37,
  },
  { isHeader: true, header: 'Summary Table', weight: 0 },
  {
    header: 'Payment Type',
    pdfHead: 'Payment Type',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',
    pdfColSx: {
      fontSize: 16, minCellWidth: 130, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'left'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 24,
  },
  {
    header: 'Item Type (Quantity)',
    pdfHead: 'Item Type (Quantity)',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 25,
  },
  {
    header: 'Freight',
    pdfHead: 'Freight',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 26,
  },
  {
    header: 'Doc Charge',
    pdfHead: 'Doc Charge',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 27,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 28,
  },
  {
    header: 'Hamali',
    pdfHead: 'Hamali',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 29,
  },
  {
    header: 'Operator Hamali',
    pdfHead: 'Operator Hamali',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 30,
  },
  {
    header: 'Freight GST',
    pdfHead: 'Freight GST',
    field: 'ServiceTaxAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 31,
  },
  {
    header: 'Cartage GST',
    pdfHead: 'Cartage GST',
    field: 'CartageTax',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 32,
  },
  {
    header: 'Hamali + Op.Hamali GST',
    pdfHead: 'Hamali + Op.Hamali GST',
    field: 'OptHamaliGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 33,
  },
  {
    header: 'Valuation Charge',
    pdfHead: 'Valuation Charge',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 34,
  },
  {
    header: 'Total',
    pdfHead: 'Total',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    Align: 'right',
    pdfColSx: {
      fontSize: 16, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'right'
    },
    isSummaryHeader: true,

    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 35,
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    weight: 65,
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    Align: 'left',
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 36,
  },

]

export const withVehicleANdChartCol = [
  {
    header: 'Vehicle\nNumber',
    pdfHead: 'Veh.\nNo.',
    field: 'VehicleNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Dispatch\nCity',
    pdfHead: 'Disp.\nCity',
    field: 'SummaryFromCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 85,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Receiving\nCity',
    pdfHead: 'Rec.\nCity',
    field: 'SummaryToCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 85,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'ToPay+\nCOD LRs',
    pdfHead: 'ToPay+\nCOD LRs',
    field: 'topayCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 4,
  },
  {
    header: 'PAID\nLRs',
    pdfHead: 'PAID\nLRs',
    field: 'paidCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 5,
  },
  {
    header: 'ON Account\nLRs',
    pdfHead: 'ONAct.\nLRs',
    field: 'onAccountCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 6,
  },
  {
    header: 'FOC +\nSelf LRs',
    pdfHead: 'FOCSelf\nLRs',
    field: 'focCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'DDDV\nLRs',
    pdfHead: 'DDDV\nLRs',
    field: 'topaydddvCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'TOTAL\nLRs',
    pdfHead: 'TOTAL\nLRs',
    field: 'totalLR',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'TOTAL\nUNITS',
    pdfHead: 'TOTAL\nUNITS',
    field: 'totalQuantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'ToPay+\nCOD Freight',
    pdfHead: 'ToPay+COD\nFrgt',
    field: 'totalToPayCodFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 115, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 11,
  },
  {
    header: 'PAID\nFreight',
    pdfHead: 'Paid\nFrgt',
    field: 'totalpaidFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 110, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'ON Account\nFreight',
    pdfHead: 'OnAct\nFrgt',
    field: 'totalOnAccountFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 110, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 13,
  },
  {
    header: 'FOC +\nSelf Freight',
    pdfHead: 'FOC+Self\nFrgt',
    field: 'totalFocFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 14,
  },
  {
    header: 'DDDV\nFreight',
    pdfHead: 'DDDV\nFrgt',
    field: 'totalDddvFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'TOTAL\nFREIGHT',
    pdfHead: 'TOTAL\nFrgt',
    field: 'totalFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'ToPay+\nCOD GST+Other',
    pdfHead: 'ToPay+COD\nGST+Oth.',
    field: 'totalToPayCodGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '120px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 17,
  },
  {
    header: 'PAID\nGST+Other',
    pdfHead: 'PAID\nGST+Oth.',
    field: 'totalpaidGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 18,
  },
  {
    header: 'ON Account\nGST+Other',
    pdfHead: 'ONAct\nGST+Oth.',
    field: 'totalOnAccountGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 19,
  },
  {
    header: 'FOC + Self\nGST+Other',
    pdfHead: 'FOC+Self\nGST+Oth',
    field: 'totalFocGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 20,
  },
  {
    header: 'DDDV\nGST+Other',
    pdfHead: 'DDDV\nGST+Oth.',
    field: 'totalTopayDddvGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 21,
  },
  {
    header: 'TOTAL\nGST+OTHER',
    pdfHead: 'Total\nGST+oth.',
    field: 'totalGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 22,
  },
  {
    header: 'TOTAL\nNET AMOUNT',
    pdfHead: 'net\nAMT.',
    field: 'totalNetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 75,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 23,
  },
  {
    header: 'Dispatch\nDate & Time',
    pdfHead: 'Disp.Date\nand Time',
    field: 'DispatchDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '110px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 110, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 24,
  },
  {
    header: 'Driver\nName',
    pdfHead: 'Driver\nName',
    field: 'SummaryDriverConductorName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 85,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 25,
  },
]
export const withVehicleANdChartColTwo = [
  {
    header: 'Vehicle\nNumber',
    pdfHead: 'Veh.\nNo.',
    field: 'VehicleNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Dispatch\nCity',
    pdfHead: 'Disp.\nCity',
    field: 'SummaryFromCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 85,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Receiving\nCity',
    pdfHead: 'Rec.\nCity',
    field: 'SummaryToCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 85,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'ToPay+\nCOD LRs',
    pdfHead: 'ToPay+\nCOD LRs',
    field: 'topayCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 4,
  },
  {
    header: 'PAID\nLRs',
    pdfHead: 'PAID\nLRs',
    field: 'paidCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 5,
  },
  {
    header: 'ON Account\nLRs',
    pdfHead: 'ONAct.\nLRs',
    field: 'onAccountCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 6,
  },
  {
    header: 'FOC +\nSelf LRs',
    pdfHead: 'FOC+Self\nLRs',
    field: 'focCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'DDDV\nLRs',
    pdfHead: 'DDDV\nLRs',
    field: 'topaydddvCount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 50,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'TOTAL\nLRs',
    pdfHead: 'TOTAL\nLRs',
    field: 'totalLR',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 55,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'TOTAL\nUNITS',
    pdfHead: 'TOTAL\nUNITS',
    field: 'totalQuantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'ToPay+\nCOD Freight',
    pdfHead: 'ToPay+COD\nFrgt',
    field: 'totalToPayCodFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 115, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 11,
  },
  {
    header: 'PAID\nFreight',
    pdfHead: 'Paid\nFrgt',
    field: 'totalpaidFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 110, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'ON Account\nFreight',
    pdfHead: 'OnAct\nFrgt',
    field: 'totalOnAccountFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 110, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 13,
  },
  {
    header: 'FOC +\nSelf Freight',
    pdfHead: 'FOC+Self\nFrgt',
    field: 'totalFocFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 14,
  },
  {
    header: 'DDDV\nFreight',
    pdfHead: 'DDDV\nFrgt',
    field: 'totalDddvFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 60,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'TOTAL\nFREIGHT',
    pdfHead: 'TOTAL\nFrgt',
    field: 'totalFreight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'ToPay+\nCOD +Other',
    pdfHead: 'ToPay+COD+\nOth.',
    field: 'totalToPayCodGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '120px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 17,
  },
  {
    header: 'PAID\n+Other',
    pdfHead: 'PAID\n+Oth.',
    field: 'totalpaidGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 18,
  },
  {
    header: 'ON Account\n+Other',
    pdfHead: 'ONAct\n+Oth.',
    field: 'totalOnAccountGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 80,
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 19,
  },
  {
    header: 'FOC + Self\n+Other',
    pdfHead: 'FOC+Self\n+Oth',
    field: 'totalFocGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 20,
  },
  {
    header: 'DDDV\n+Other',
    pdfHead: 'DDDV\n+Oth.',
    field: 'totalTopayDddvGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 65,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 21,
  },
  {
    header: 'TOTAL\n+OTHER',
    pdfHead: 'Total\n+Oth.',
    field: 'totalGstOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 70,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 22,
  },
  {
    header: 'TOTAL\nNET AMOUNT',
    pdfHead: 'net\nAMT.',
    field: 'totalNetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    weight: 75,
    headerSx: { minWidth: '90px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 23,
  },
  {
    header: 'Dispatch\nDate & Time',
    pdfHead: 'Disp.Date\nand Time',
    field: 'DispatchDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 90,
    headerSx: { minWidth: '110px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 110, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 24,
  },
  {
    header: 'Driver\nName',
    pdfHead: 'Driver\nName',
    field: 'SummaryDriverConductorName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    weight: 85,
    headerSx: { minWidth: '100px', textAlign: 'left' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, halign: 'left'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 25,
  },
]


export const withPaymentTypeCol = [
  {
    header: 'SN',
    pdfHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '20px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 0,
  },
  {
    header: 'LR No.\nChallanNo.\nManual LR No.',
    pdfHead: 'LR No.\nChallanNo.\nManual LR No.',
    field: 'LRNO^^VoucherNo^^ManualLR',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Vehicle\nNo.',
    pdfHead: 'Vehicle\nNo.',
    field: 'VehicleNoFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Dispatch\nDate & Time',
    pdfHead: 'Dispatch\nDate & Time',
    field: 'DispatchDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'Source\nCity',
    pdfHead: 'Source\nCity',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 4,
  },
  {
    header: `Destination\nCity`,
    pdfHead: `Destination\nCity`,
    field: 'ToCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 5,
  },
  {
    header: 'Dispatch\nTo City',
    pdfHead: 'Dispatch\nTo City',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 6,
  },
  {
    header: 'Dispatch\nTo Branch',
    pdfHead: 'Dispatch\nTo Branch',
    field: 'DispatchedToBranchFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'Sender\nDetails',
    pdfHead: 'Sender Name\nSender Mobile\nSender GSTN\nSender Email',
    field: 'SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'Receiver\nDetails',
    pdfHead: 'Receiver Name\nReceiver Mobile\nReceiver GSTN\nReceiver Email',
    field: 'RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'Item\nDetails',
    pdfHead: 'Item\nDetails',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'Units',
    pdfHead: 'Units',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 11,
  },
  {
    header: 'Freight',
    pdfHead: 'Freight',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'Hamali',
    pdfHead: 'Hamali',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 13,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 14,
  },
  {
    header: 'Valuation',
    pdfHead: 'Valuation',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'Other\nCharges',
    pdfHead: 'Other\nCharges',
    field: 'AllOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'Net\nAmount',
    pdfHead: 'Net\nAmount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 17,
  },
]

export const withPaymentTypeColWithFormat = [
  {
    header: 'SN',
    pdfHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '20px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    pdfColSx: {
      fontSize: 18, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 0,
  },
  {
    header: 'LR No.\nChallanNo.\nManual LR No.',
    pdfHead: 'LR No.\nChallanNo.\nManual LR No.',
    field: 'LRNO^^VoucherNo^^ManualLR',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 1,
  },
  {
    header: 'Formatted\nLR No',
    pdfHead: 'Formatted\nLR No',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 18,
  },
  {
    header: 'Vehicle\nNo.',
    pdfHead: 'Vehicle\nNo.',
    field: 'VehicleNoFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 2,
  },
  {
    header: 'Dispatch\nDate & Time',
    pdfHead: 'Dispatch\nDate & Time',
    field: 'DispatchDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 3,
  },
  {
    header: 'Source\nCity',
    pdfHead: 'Source\nCity',
    field: 'BookCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 4,
  },
  {
    header: `Destination\nCity`,
    pdfHead: `Destination\nCity`,
    field: 'ToCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 5,
  },
  {
    header: 'Dispatch\nTo City',
    pdfHead: 'Dispatch\nTo City',
    field: 'DispatchedToCityFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 6,
  },
  {
    header: 'Dispatch\nTo Branch',
    pdfHead: 'Dispatch\nTo Branch',
    field: 'DispatchedToBranchFilter',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 7,
  },
  {
    header: 'Sender\nDetails',
    pdfHead: 'Sender Name\nSender Mobile\nSender GSTN\nSender Email',
    field: 'SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 8,
  },
  {
    header: 'Receiver\nDetails',
    pdfHead: 'Receiver Name\nReceiver Mobile\nReceiver GSTN\nReceiver Email',
    field: 'RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 9,
  },
  {
    header: 'Item\nDetails',
    pdfHead: 'Item\nDetails',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '120px', textAlign: 'left' },
    Align: 'left',

    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
    isSummaryHeader: false,
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 10,
  },
  {
    header: 'Units',
    pdfHead: 'Units',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 11,
  },
  {
    header: 'Freight',
    pdfHead: 'Freight',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 12,
  },
  {
    header: 'Hamali',
    pdfHead: 'Hamali',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 13,
  },
  {
    header: 'Cartage',
    pdfHead: 'Cartage',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 14,
  },
  {
    header: 'Valuation',
    pdfHead: 'Valuation',
    field: 'Insurance',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 15,
  },
  {
    header: 'Other\nCharges',
    pdfHead: 'Other\nCharges',
    field: 'AllOther',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSortIcon: true,
    id: 16,
  },
  {
    header: 'Net\nAmount',
    pdfHead: 'Net\nAmount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    pdfColSx: {
      fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
    },
    allowSorting: true,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
    id: 17,
  },
]
export const withPaymentTypeExcelCol = [
  {
    header: 'Serial Number',
    field: 'SN',
    headerSx: {
      minWidth: '20px', textAlign: 'right', whiteSpace: 'nowrap'
    },
  },
  {
    header: 'LR Number',
    field: 'OnlyLRNo',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Challan Number',
    field: 'OnlyLRNo',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Manual LR Number',
    field: 'LRNO',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Formatted LR Number',
    field: 'FormattedLRNO',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Vehicle\nNumber',
    pdfHead: 'Vehicle\nNo.',
    field: 'VehicleNoFilter',
    headerSx: { minWidth: '120px', textAlign: 'left' },

  },
  {
    header: 'Dispatch\nDate & Time',
    pdfHead: 'Dispatch\nDate & Time',
    field: 'DispatchDateTime',
    headerSx: { minWidth: '120px', textAlign: 'left' },

  },
  {
    header: 'Source\nCity',
    pdfHead: 'Source\nCity',
    field: 'BookCity',
    headerSx: { minWidth: '120px', textAlign: 'left' },

  },
  {
    header: `Destination\nCity`,
    field: 'ToCity',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Dispatch\nTo City',
    field: 'DispatchedToCityFilter',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Dispatch\nTo Branch',
    field: 'DispatchedToBranchFilter',
    headerSx: { minWidth: '120px', textAlign: 'left' },

  },
  {
    header: 'Sender Name',
    field: 'SenderName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Sender Mobile Number',
    field: 'SenderName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Sender GSTN',
    field: 'SenderName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Sender EmailID',
    field: 'SenderName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Receiver Name',
    field: 'RecName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Receiver Mobile Number',
    field: 'RecName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Receiver GSTN',
    field: 'RecName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Receiver EmailID',
    field: 'RecName',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Item\nDetails',
    field: 'ItemDetails',
    headerSx: { minWidth: '120px', textAlign: 'left' },
  },
  {
    header: 'Units',
    field: 'Quantity',
    headerSx: { minWidth: '100px', textAlign: 'right' },
  },
  {
    header: 'Freight',
    field: 'Freight',
    headerSx: { minWidth: '100px', textAlign: 'right' },
  },
  {
    header: 'Hamali',
    field: 'HamaliCharges',
    headerSx: { minWidth: '100px', textAlign: 'right' },
  },
  {
    header: 'Cartage',
    field: 'CartageAmount',
    headerSx: { minWidth: '100px', textAlign: 'right' },
  },
  {
    header: 'Valuation',
    field: 'Insurance',
    headerSx: { minWidth: '100px', textAlign: 'right' },
  },
  {
    header: 'Other\nCharges',
    field: 'AllOther',
    headerSx: { minWidth: '100px', textAlign: 'right' },
  },
  {
    header: 'Net\nAmount',
    field: 'NetAmount',
    headerSx: { minWidth: '100px', textAlign: 'right' },
  },
]




export const ShowOnlyToPayAmtCol = [
  {
    header: 'LR NO.',
    pdfHead: 'LR\nNO.',
    field: 'OnlyLRNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Manual LR',
    pdfHead: 'Manual\nLR',
    field: 'ManualLR',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender Name',
    pdfHead: 'Sender\nName',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender GSTIN',
    pdfHead: 'Sender\nGSTIN',
    field: 'SenderGSTN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver Name',
    pdfHead: 'Receiver\nName',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver GSTIN',
    pdfHead: 'Receiver\nSTIN',
    field: 'ReceiverGSTN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'No. of Parcels',
    pdfHead: 'No. of \nParcels',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Goods Description',
    pdfHead: 'Goods\nDescription',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Total Amount',
    pdfHead: 'Total\nAmount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },



]

export const ShowOnlyToPayAmtSummaryCol = [
  {
    header: 'Paid',
    field: '1',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay',
    field: '2',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'FOC',
    field: '3',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'COD',
    field: '4',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account',
    field: '5',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid(Manual)',
    field: '6',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'To Pay(Manual)',
    field: '7',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Self Booking',
    field: '8',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay (DDDV)',
    field: '9',
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account(Manual)',
    field: '10',
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
  {
    header: 'Total',
    field: '11',
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
]
export const showOnlyToPayAmtSummaryExcel = [
  [
    { header: 'Vehicle Number', field: 'vehicleNo', rowSpan: 2 },
    { header: 'Paid', span: 2 },
    { header: 'ToPay', span: 2 },
    { header: 'FOC', span: 2 },
    { header: 'On Account', span: 2 },
    { header: 'Paid (Manual)', span: 2 },
    { header: 'To Pay (Manual)', span: 2 },
    { header: 'Self Booking', span: 2 },
    { header: 'ToPay (DDDV)', span: 2 },
    { header: 'On Account (Manual)', span: 2 },
    { header: 'Total Totals', span: 2 },
  ],
  [
    { header: 'Vehicle Number', field: 'vehicleNo', skip: true, mainHeader: true },
    { header: 'Quantity', field: 'paidQuantity' },
    { header: 'Amount', field: 'paidAmount' },
    { header: 'Quantity', field: 'toPayQuantity' },
    { header: 'Amount', field: 'toPayAmount' },
    { header: 'Quantity', field: 'fOCQuantity' },
    { header: 'Amount', field: 'fOCAmount' },
    { header: 'Quantity', field: 'onAccountQuantity' },
    { header: 'Amount', field: 'onAccountAmount' },
    { header: 'Quantity', field: 'paid(Manual)Quantity' },
    { header: 'Amount', field: 'paid(Manual)Amount' },
    { header: 'Quantity', field: 'toPay(Manual)Quantity' },
    { header: 'Amount', field: 'toPay(Manual)Amount' },
    { header: 'Quantity', field: 'selfQuantity' },
    { header: 'Amount', field: 'selfAmount' },
    { header: 'Quantity', field: 'toPay(DDDV)Quantity' },
    { header: 'Amount', field: 'toPay(DDDV)Amount' },
    { header: 'Quantity', field: 'onAccount(Manual)Quantity' },
    { header: 'Amount', field: 'onAccount(Manual)Amount' },
    { header: 'Units', field: 'totalUnits' },
    { header: 'Amount', field: 'totalAmount' },
  ],
]
export const showOnlyToPayCol = [
  { isHeader: true, header: 'Detailed Table' },
  {
    header: 'LR Number',
    pdfHead: 'LR\nNO.',
    field: 'OnlyLRNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 1,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Manual LR',
    pdfHead: 'Manual\nLR',
    field: 'ManualLR',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 2,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender Name',
    pdfHead: 'Sender\nName',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 3,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender GSTIN',
    pdfHead: 'Sender\nGSTIN',
    field: 'SenderGSTN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: false,
    id: 4,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver Name',
    pdfHead: 'Receiver\nName',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 5,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver GSTIN',
    pdfHead: 'Receiver\nGSTIN',
    field: 'ReceiverGSTN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: false,
    id: 6,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Number of Parcels',
    pdfHead: 'No. of \nParcels',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 7,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Goods Description',
    pdfHead: 'Goods\nDescription',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 8,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 9,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Total Amount',
    pdfHead: 'Total\nAmount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 10,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 11,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  { isHeader: true, header: 'Summary Table' },
  {
    header: 'Vehicle Number',
    field: '0',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 12,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid',
    field: '1',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 13,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay',
    field: '2',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 14,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'FOC',
    field: '3',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 15,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'COD',
    field: '4',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 16,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account',
    field: '5',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 17,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid(Manual)',
    field: '6',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 18,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'To Pay(Manual)',
    field: '7',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 19,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Self Booking',
    field: '8',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 20,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay (DDDV)',
    field: '9',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 21,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account(Manual)',
    field: '10',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 22,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
  {
    header: 'Total',
    field: '11',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 23,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
]

export const showOnlyToPayColTwo = [
  { isHeader: true, header: 'Detailed Table' },
  {
    header: 'LR Number',
    pdfHead: 'LR\nNO.',
    field: 'OnlyLRNo',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 1,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Manual LR',
    pdfHead: 'Manual\nLR',
    field: 'ManualLR',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 2,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender Name',
    pdfHead: 'Sender\nName',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 3,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver Name',
    pdfHead: 'Receiver\nName',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 5,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Number of Parcels',
    pdfHead: 'No. of \nParcels',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 7,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Goods Description',
    pdfHead: 'Goods\nDescription',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 8,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 9,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Total Amount',
    pdfHead: 'Total\nAmount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 10,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 11,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  { isHeader: true, header: 'Summary Table' },
  {
    header: 'Vehicle Number',
    field: '0',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 12,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid',
    field: '1',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 13,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay',
    field: '2',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 14,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'FOC',
    field: '3',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 15,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'COD',
    field: '4',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 16,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account',
    field: '5',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 17,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid(Manual)',
    field: '6',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 18,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'To Pay(Manual)',
    field: '7',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 19,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Self Booking',
    field: '8',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 20,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay (DDDV)',
    field: '9',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 21,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account(Manual)',
    field: '10',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 22,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
  {
    header: 'Total',
    field: '11',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 23,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
]

export const showOnlyToPayColWithFormat = [
  { isHeader: true, header: 'Detailed Table' },
  {
    header: 'LR Number',
    pdfHead: 'LR\nNO.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 1,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Manual LR',
    pdfHead: 'Manual\nLR',
    field: 'ManualLR',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 2,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Formatted LR No',
    pdfHead: 'Formatted LR No',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 24,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender Name',
    pdfHead: 'Sender\nName',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 3,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender GSTIN',
    pdfHead: 'Sender\nGSTIN',
    field: 'SenderGSTN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: false,
    id: 4,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver Name',
    pdfHead: 'Receiver\nName',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 5,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver GSTIN',
    pdfHead: 'Receiver\nGSTIN',
    field: 'ReceiverGSTN',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: false,
    id: 6,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Number of Parcels',
    pdfHead: 'No. of \nParcels',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 7,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Goods Description',
    pdfHead: 'Goods\nDescription',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 8,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 9,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Total Amount',
    pdfHead: 'Total\nAmount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 10,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 11,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  { isHeader: true, header: 'Summary Table' },
  {
    header: 'Vehicle Number',
    field: '0',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 12,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid',
    field: '1',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 13,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay',
    field: '2',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 14,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'FOC',
    field: '3',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 15,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'COD',
    field: '4',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 16,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account',
    field: '5',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 17,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid(Manual)',
    field: '6',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 18,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'To Pay(Manual)',
    field: '7',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 19,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Self Booking',
    field: '8',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 20,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay (DDDV)',
    field: '9',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 21,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account(Manual)',
    field: '10',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 22,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
  {
    header: 'Total',
    field: '11',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 23,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
]

export const showOnlyToPayColWithFormatTwo = [
  { isHeader: true, header: 'Detailed Table' },
  {
    header: 'LR Number',
    pdfHead: 'LR\nNO.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 1,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Manual LR',
    pdfHead: 'Manual\nLR',
    field: 'ManualLR',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 2,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Formatted LR No',
    pdfHead: 'Formatted LR No',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 24,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Sender Name',
    pdfHead: 'Sender\nName',
    field: 'SenderName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 3,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Receiver Name',
    pdfHead: 'Receiver\nName',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '120px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 5,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Number of Parcels',
    pdfHead: 'No. of \nParcels',
    field: 'Quantity',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 7,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Goods Description',
    pdfHead: 'Goods\nDescription',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 8,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    field: 'PaymentType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 9,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  {
    header: 'Total Amount',
    pdfHead: 'Total\nAmount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '80px', textAlign: 'right', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 10,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'right'
    },
  },
  {
    header: 'Remarks',
    pdfHead: 'Remarks',
    field: 'Remarks',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: {
      minWidth: '100px', textAlign: 'left', whiteSpace: 'nowrap'
    },
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: false,
    id: 11,
    isSortIcon: true,
    pdfColSx: {
      fontSize: 18, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', halign: 'left'
    },
  },
  { isHeader: true, header: 'Summary Table' },
  {
    header: 'Vehicle Number',
    field: '0',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 12,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid',
    field: '1',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 13,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay',
    field: '2',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 14,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'FOC',
    field: '3',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 15,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'COD',
    field: '4',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 16,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account',
    field: '5',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 17,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Paid(Manual)',
    field: '6',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 18,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'To Pay(Manual)',
    field: '7',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 19,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'Self Booking',
    field: '8',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 20,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'ToPay (DDDV)',
    field: '9',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSummaryHeader: true,
    id: 21,
    isSortIcon: true,
    headerSx: {
      minWidth: '100px', textAlign: 'center',
    },
  },
  {
    header: 'On Account(Manual)',
    field: '10',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 22,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
  {
    header: 'Total',
    field: '11',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    isSummaryHeader: true,
    id: 23,
    isSortIcon: true,
    headerSx: {
      minWidth: '150px', textAlign: 'center',
    },
  },
]
export const showOnlyToPayAmountSummaryColumn = [
  {
    headerName: 'Veh.\nNo',
    exportHead: 'Veh.\nNo',
    field: 'vehicleNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true,
    field1: '0',
    isSortIcon: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'left', minCellWidth: 100
    }
  },
  {
    headerName: 'Paid \nUnit',
    exportHead: 'Paid\nUnit',
    field: 'paidQuantity',
    field1: '1',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'Paid \nAmt.',
    exportHead: 'Paid\nAmt.',
    field: 'paidAmount',
    field1: '1',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'Topay \nUnit',
    exportHead: 'Topay\nUnit',
    field: 'toPayQuantity',
    field1: '2',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'Topay \nAmt.',
    exportHead: 'Topay\nAmt.',
    field: 'toPayAmount',
    field1: '2',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'FOC \nUnit',
    exportHead: 'FOC\nUnit',
    field: 'fOCQuantity',
    field1: '3',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'FOC \nAmt.',
    exportHead: 'FOC\nAmt.',
    field: 'fOCAmount',
    field1: '3',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'COD \nUnit',
    exportHead: 'COD\nUnit',
    field: 'cODQuantity',
    field1: '4',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'COD \nAmt.',
    exportHead: 'COD\nAmt.',
    field: 'cODAmount',
    field1: '4',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'OnAct \nUnit',
    exportHead: 'OnAct\nUnit',
    field: 'onAccountQuantity',
    field1: '5',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'OnAct \nAmt.',
    exportHead: 'OnAct\nAmt.',
    field: 'onAccountAmount',
    field1: '5',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'PaidMan.\nUnit',
    exportHead: 'PaidMan.\nUnit',
    field: 'paid(Manual)Quantity',
    field1: '6',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'PaidMan.\nAmt.',
    exportHead: 'PaidMan.\nAmt.',
    field: 'paid(Manual)Amount',
    field1: '6',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'TopayMan.\nUnit',
    exportHead: 'TopayMan.\nUnit',
    field: 'toPay(Manual)Quantity',
    field1: '7',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'TopayMan.\nAmt.',
    exportHead: 'TopayMan.\nAmt.',
    field: 'toPay(Manual)Amount',
    field1: '7',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'SelfBkg.\nUnit',
    exportHead: 'SelfBkg.\nUnit',
    field: 'selfQuantity',
    field1: '8',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'SelfBkg.\nAmt.',
    exportHead: 'SelfBkg.\nAmt.',
    field: 'selfAmount',
    field1: '8',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'toPay(DDDV).\nUnit',
    exportHead: 'toPay(DDDV).\nUnit',
    field: 'toPay(DDDV)Quantity',
    field1: '9',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'toPay(DDDV).\nAmt.',
    exportHead: 'toPay(DDDV).\nAmt.',
    field: 'toPay(DDDV)Amount',
    field1: '9',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'OnActMan.\nUnit',
    exportHead: 'OnActMan.\nUnit',
    field: 'onAccount(Manual)Quantity',
    field1: '10',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'OnActMan.\nAmt.',
    exportHead: 'OnActMan.\nAmt.',
    field1: '10',
    isSortIcon: true,
    field: 'onAccount(Manual)Amount',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'Total\nUnits',
    exportHead: 'Total\nUnits',
    field: 'totalUnits',
    field1: '11',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
  {
    headerName: 'Total\nAmt',
    exportHead: 'Total\nAmt',
    field: 'totalAmount',
    field1: '11',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true,
    pdfColSx: {
      fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 100
    }
  },
]
export const getVehicleWithDispatchSummaryColumn = (UseToPayAsCOD = 0) => [
  {
    headerName: 'Serial\nNumber',
    exportHead: 'SN',
    field: 'SN',
    xlCol: { dataType: 'string', dataFormatter: null, },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Vehicle Number \nSeal Number',
    exportHead: 'Vehicle No. \nSeal No.',
    field: 'BusNumber^^SealNo',
    isSortIcon: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Dispatch From City \nDispatch From Branch',
    exportHead: 'Disp.From City \nDisp.From Branch',
    field: 'FromCityName^^FromBranchName',
    isSortIcon: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Dispatch To City \nDispatch To Branch',
    exportHead: 'Disp. To City. \nDisp. To Branch',
    field: 'ToCityName^^ToBranchName',
    isSortIcon: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Trip Date \n& Time',
    exportHead: 'Trip Date \n& Time',
    field: 'DispatchDateTime',
    isSortIcon: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Driver Name \nDriver Number',
    exportHead: 'Drvr. Name \nDrvr. Number',
    field: 'DriverConductorName^^ContactNo',
    isSortIcon: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Paid \nUnit',
    exportHead: 'Paid \nUnit',
    field: 'PaidUnit',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: UseToPayAsCOD ? 'COD \nUnit' : 'ToPay \nUnit',
    exportHead: UseToPayAsCOD ? 'COD \nUnit' : 'ToPay \nUnit',
    field: 'TopayUnit',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'On-Acct \nUnit',
    exportHead: 'On-Acct \nUnit',
    field: 'OnAccountUnit',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'FOC + Self \nUnit',
    exportHead: 'FOC + Self \nUnit',
    field: 'FocAndSelfUnit',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Total \nUnit',
    exportHead: 'Total \nUnit',
    field: 'TotalUnits',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', border: '1px solid #aeaeae', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: { borderRight: '1px solid #ccc' }
  },
  {
    headerName: 'Paid \nAmount',
    exportHead: 'Paid \nAmount',
    field: 'PaidTotal',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: UseToPayAsCOD ? 'COD \nAmount' : 'ToPay \nAmount',
    exportHead: UseToPayAsCOD ? 'COD \nAmount' : 'ToPay \nAmount',
    field: 'ToPayTotal',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'On-Acct \nAmount',
    exportHead: 'On-Acct \nAmount',
    field: 'OnAccountTotal',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'FOC + Self \nAmount',
    exportHead: 'FOC + Self \nAmount',
    field: 'FOCTotal',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
  {
    headerName: 'Total \nAmount',
    exportHead: 'Total \nAmount',
    field: 'TotalNetAmount',
    isSortIcon: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  },
];

export const headerColumnChallanWiseDispatchSummaryColumn = [
  { headerName: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left",isSortIcon: false, showfilter: true },
  { headerName: 'Destination', exportHead: 'Destination', field: 'ToCity', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left",isSortIcon: true, showfilter: true },
  { headerName: 'From-To', exportHead: 'From-To', field: 'FromTo', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left",isSortIcon: true, showfilter: true },
  { headerName: 'Challan No Wise Detail', exportHead: 'Challan No Wise Detail', field: 'ItemDetails', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left",isSortIcon: true, showfilter: true },
  { headerName: 'Dispatch Date', exportHead: 'Dispatch Date', field: 'DispatchDate', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right",isSortIcon: true, showfilter: true },
  { headerName: 'NOP', exportHead: 'NOP', field: 'Quantity', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right",isSortIcon: true, showfilter: true },
  { headerName: 'Total', exportHead: 'Total', field: 'Total', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left",isSortIcon: true, showfilter: true },
  { headerName: 'Less', exportHead: 'Less', field: 'Less', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left",isSortIcon: true, showfilter: true },
]
export const headerColumnRechargePenalty = [
  { header: 'City\nName', exportHead: 'City\nName', field: 'CityName', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Branch\nName', exportHead: 'Branch\nName', field: 'BranchName', xlCol: xlCol, isSortIcon: true, weight: 30 , align: "left", showfilter: true },
  { header: 'Recharge Request\nDate & Time', exportHead: 'Recharge Request\nDate & Time', field: 'RechargeRequestDate', xlCol: xlCol,isSortIcon: true, weight: 30 , align: "left", showfilter: true },
  { header: 'Request Raised\nBy User', exportHead: 'Request Raised\nBy User', field: 'RequestRaisedByUser', xlCol: xlCol,isSortIcon: true, weight: 30 , align: "left", showfilter: true },
  { header: 'Total Recharge\nAmount', exportHead: 'Total Rec.\nAmount', field: 'TotalRechargeAmount', xlCol: xlCol,isSortIcon: true, weight: 30 , align: "right", showfilter: true },
  { header: 'Recharge Penalty\nAmount', exportHead: 'Recharge Penalty\nAmount', field: 'PenaltyAmount', xlCol: xlCol,isSortIcon: true, weight: 30 , align: "right", showfilter: true },
  { header: 'Recharge Accept\nDate & Time', exportHead: 'Recharge Accept\nDate & Time', field: 'AcceptDateTime', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Recharge Accepted\nBy User', exportHead: 'Recharge Accepted\nBy User', field: 'AcceptByUser', xlCol: xlColq, isSortIcon: true, weight: 30, align: "left", showfilter: true },
]
export const headerColumnRechargePenaltyForSTA = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: xlCol, weight: 30, align: "left", showfilter: false },
  { header: 'Penalty\nBranch City', exportHead: 'Penalty\nBranch City', field: 'CityName', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Penalty\nBranch Name', exportHead: 'Penalty\nBranch Name', field: 'BranchName', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Penalty\nDate & Time', exportHead: 'Penalty\nDate & Time', field: 'PenaltyDate', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Source\nBranch', exportHead: 'Source\nBranch', field: 'SourceBranch', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Destination\nBranch', exportHead: 'Destination\nBranch', field: 'DestBranch', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Booked\nBy User', exportHead: 'Booked\nBy User', field: 'BookedByUser', xlCol: xlCol, isSortIcon: true, weight: 30, align: "left", showfilter: true },
  { header: 'Penalty\nAmount', exportHead: 'Penalty\nAmount', field: 'PenaltyAmount', xlCol: xlColq, isSortIcon: true, weight: 30, align: "right", showfilter: true },
]
export const headerFilterColumnRechargePenalty = [
  { header: 'From Transaction Date', exportHead: 'From Transaction Date', field: 'FromDate', xlCol: xlCol, align: "left" },
  { header: 'To Transaction Date', exportHead: 'To Transaction Date', field: 'ToDate', xlCol: xlCol, align: "left" },
  { header: 'City Name', exportHead: 'City Name', field: 'City', xlCol: xlCol, align: "left" },
  { header: 'Branch Name', exportHead: 'Branch Name', field: 'Branch', xlCol: xlCol, align: "left" },
]
export const ColumnUserwithTransRightReport = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: xlCol, align: "left", showfilter: false, weight: 30 },
  { header: 'City Name', exportHead: 'City Name', field: 'CityName', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
  { header: 'Branch Name', exportHead: 'Branch Name', field: 'BranchName', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
  { header: 'User Name', exportHead: 'User Name', field: 'username', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
  { header: 'User Category', exportHead: 'User Category', field: 'roleName', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
  { header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
  { header: 'Booking Rights', exportHead: 'Booking Rights', field: 'BookingRights', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
  { header: 'Refund Rights', exportHead: 'Refund Rights', field: 'RefundRights', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
  { header: 'Delivery Rights', exportHead: 'Delivery Rights', field: 'DeliveryRights', xlCol: xlCol, align: "left", showfilter: true, isSortIcon: true, weight: 30 },
]
export const headerFilterColumnUserwithTransRightReport = [
  { header: 'Company', exportHead: 'Company', field: 'company', xlCol: xlCol, align: "left" },
  { header: 'City', exportHead: 'City', field: 'city', xlCol: xlCol, align: "left" },
  { header: 'Branch', exportHead: 'Branch', field: 'branch', xlCol: xlCol, align: "left" },
  { header: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: xlCol, align: "left" },
]
export const headerColumnPartyTargetReport = [
  { header: 'Serial Number', exportHead: 'SN', field: 'SN', xlCol: xlCol,align:'left', weight: 30, showfilter: true},
  { header: 'Party Name', exportHead: 'Party Name', field: 'PartyName', xlCol: xlCol,align:'left', isSortIcon: true, weight: 40, showfilter: true},
  { header: 'Party City', exportHead: 'Party City', field: 'CityName', xlCol: xlCol,align:'left', isSortIcon: true, weight: 30, showfilter: true},
  { header: 'Parent Branch', exportHead: 'Parent Branch', field: 'BranchName', xlCol: xlCol,align:'left', isSortIcon: true, weight: 40, showfilter: true},
  { header: 'From Target Date', exportHead: 'From Tgt Date', field: 'TargetStartDate', xlCol: xlCol,align:'left', isSortIcon: true, weight: 40, showfilter: true},
  { header: 'To Target Date', exportHead: 'To Tgt Date', field: 'TargetEndDate', xlCol: xlCol,align:'left', isSortIcon: true, weight: 40, showfilter: true},
  { header: 'Target Type', exportHead: 'Target Type', field: 'targetType', xlCol: xlCol,align:'left', isSortIcon: true, weight: 30, showfilter: true},
  { header: 'Target value', exportHead: 'Target value', field: 'TargetAmount', xlCol: xlColq,align:'right', isSortIcon: true, weight: 30, showfilter: true},
  { header: 'Target Progress', exportHead: 'Target Progress', field: 'TargetProgress', xlCol: xlColq,align:'right', isSortIcon: true, weight: 40, showfilter: true},
  { header: 'LR Count', exportHead: 'LR Count', field: 'TotalLRs', xlCol: xlColq,align:'right', isSortIcon: true, weight: 30, showfilter: true},
  { header: 'Total Units', exportHead: 'Total Units', field: 'TotalItems', xlCol: xlColq,align:'right', isSortIcon: true, weight: 30, showfilter: true},
  { header: 'Total Amount', exportHead: 'Total Amount', field: 'TotalNetAmounts', xlCol: xlColq,align:'right', isSortIcon: true, weight: 30, showfilter: true},
  { header: 'Party Status', exportHead: 'Party Status', field: 'status', xlCol: xlCol,align:'left', isSortIcon: true, weight: 30, showfilter: true},
]
export const headerFilterColumnPartyTargetReport = [
  { header: 'Company', exportHead: 'Company', field: 'comapny', xlCol: xlCol, minWidth: "80px", align: "left" },
  { header: 'From booking Date', exportHead: 'From booking Date', field: 'fromDate', xlCol: xlCol, minWidth: "100px", align: "left" },
  { header: 'To Booking Date', exportHead: 'To Booking Date', field: 'toDate', xlCol: xlCol, minWidth: "80px", align: "left" },
  { header: 'Party City', exportHead: 'Party City', field: 'partyCity', xlCol: xlCol, minWidth: "100px", align: "left" },
  { header: 'Party Name', exportHead: 'Party Name', field: 'partyName', xlCol: xlCol, minWidth: "100px", align: "left" },
]
export const headerColumnToPayDestinationReport = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", isSortIcon: false },
  { header: 'LR Date', exportHead: 'LR Date', field: 'LRDate', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", isSortIcon: true },
  { header: 'Destination City', exportHead: ' Destination City', field: 'Station', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left", isSortIcon: true },
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'Branch', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", isSortIcon: true },
  { header: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", isSortIcon: true },
  { header: 'Challan Number', exportHead: 'Challan Number', field: 'CHALLANNO', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", isSortIcon: true },
  { header: 'Vehicle', exportHead: 'Vehicle', field: 'VEHICLE', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", isSortIcon: true },
  { header: 'Units', exportHead: 'Units', field: 'NOPS', xlCol: { dataType: 'quantity', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", isSortIcon: true },
  { header: 'Total', exportHead: 'Total', field: 'Total', xlCol: { dataType: 'quantity', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", isSortIcon: true },
]
export const headerFilterColumnToPayDestinationReport = [
  { headerName: 'Company', exportHead: 'Company', field: 'company', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left", colSpan: 2 },
  { headerName: 'From Date', exportHead: 'From Date', field: 'fromDate', xlCol: { dataType: 'number', dataFormatter: null }, span: 2, align: "left", colSpan: 1 },
  { headerName: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: { dataType: 'number', dataFormatter: null }, span: 2, align: "left", colSpan: 1 },
  { headerName: 'Source City', exportHead: 'Source City', field: 'sourceCity', xlCol: { dataType: 'number', dataFormatter: null }, span: 2, align: "left", colSpan: 2 },
  { headerName: 'Source Branch', exportHead: 'Source Branch', field: 'sourceBranch', xlCol: { dataType: 'number', dataFormatter: null }, span: 2, align: "left", colSpan: 2 },
  { headerName: 'Destination City', exportHead: 'Destination City', field: 'destinationCity', xlCol: { dataType: 'number', dataFormatter: null }, span: 2, align: "left", colSpan: 2 },
  { headerName: 'Destination Branch', exportHead: 'Destination Branch', field: 'destinationBranch', xlCol: { dataType: 'string', dataFormatter: null }, span: 1, align: "left", colSpan: 2 },
]

export const getVehicleAndChartDateSummaryColumns = (loginCountryId, UseToPayAsCOD) => {
  let columns = [
    {
      headerName: 'Vehicle \nNumber',
      exportHead: 'Veh. \nNo. ',
      field: 'VehicleNo',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Trip \nName',
      exportHead: 'Trip \nName',
      field: 'UniqueTripNames',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Trip \nID',
      exportHead: 'Trip \nID',
      field: 'UniqueTripIDs',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Chart \nDate',
      exportHead: 'Chart \nDate',
      field: 'UniqueChartDate',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Number\nof Parcel',
      exportHead: 'NOP',
      field: 'Quantity',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Paid \nFreight',
      exportHead: 'Paid \nFrgt.',
      field: 'paidFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'ToPay + COD \nFreight',
      exportHead: 'To + COD \nFrgt.',
      field: 'ToPayCodFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'OnAccount \nFreight',
      exportHead: 'OnAct \nFrgt.',
      field: 'OnAccountFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'DDDV \nFreight',
      exportHead: 'DDDV \nFrgt.',
      field: 'DddvFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'FOC \nFreight',
      exportHead: 'FOC \nFrgt.',
      field: 'FocFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Self \nFreight',
      exportHead: 'Self \nFrgt.',
      field: 'SelfFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Total \nFreight',
      exportHead: 'Total \nFrgt.',
      field: 'totalFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Cartage',
      exportHead: 'Cartage',
      field: 'SummaryAllCartage',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Hamali',
      exportHead: 'Hamali',
      field: 'SummaryAllHamali',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Other \nCharge',
      exportHead: 'Other \nChrg',
      field: 'SummaryAllOther',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: loginCountryId === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
      exportHead: loginCountryId === 2 ? 'Insu.\nCharg' : 'Val.\nCharg',
      field: 'SummaryInsurance',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    ...(loginCountryId !== 2
      ? [
        {
          headerName: 'GST',
          exportHead: 'GST',
          field: 'SummaryServiceTaxAmount',
          xlCol: { dataType: 'number', dataFormatter: null },
          isSortIcon: true,
        },
      ]
      : []),
    {
      headerName: 'Net\nAmount',
      exportHead: 'Net\nAmt',
      field: 'SummaryNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
  ];
  if (UseToPayAsCOD === 1) {
    columns = columns.map((col) => {
      if (col.field === 'ToPayCodFreight') {
        return { ...col, headerName: 'COD \nFreight', exportHead: 'COD \nFrgt.' };
      }
      return col;
    });
  }

  return columns;
};
export const getWithHamaliAndCartageSummaryColumn = (loginCountryId, UseToPayAsCOD) => {
  let columns = [
    {
      headerName: 'Serian\nNumber',
      exportHead: 'SN',
      field: 'SN',
      xlCol: { dataType: 'string', dataFormatter: null },
    },
    {
      headerName: 'Vehicle \nNumber',
      exportHead: 'Vehicle \nNo',
      field: 'BusNumber',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Driver Name &\nContact',
      exportHead: 'Driver Name &\nContact',
      field: 'DriverConductorName^^ContactNo',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Dispatch\nTo City',
      exportHead: 'Dispatch\nTo City',
      field: 'Station',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Number of Parcel\n(Units)',
      exportHead: 'NOP\n(Units)',
      field: 'TotalUnits',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Total\nLRs',
      exportHead: 'Total\nLRs',
      field: 'TotalLRCount',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Total \nFreight',
      exportHead: 'Total \nFreight',
      field: 'TotalFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'ToPay + COD \nFreight',
      exportHead: 'ToPay + COD \nFreight',
      field: 'TopayFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Paid \nFreight',
      exportHead: 'Paid \nFreight',
      field: 'PaidFreight',
      xlCol: { dataType: 'quantity', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'On-Account \nFreight',
      exportHead: 'On-Account \nFreight',
      field: 'OnAccountFreight',
      xlCol: { dataType: 'quantity', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'FOC + Self \nFreight',
      exportHead: 'FOC + Self \nFreight',
      field: 'FocAndSelfFreight',
      xlCol: { dataType: 'quantity', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'DDDV \nFreight',
      exportHead: 'DDDV \nFreight',
      field: 'DDDVFreight',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Hamali',
      exportHead: 'Hamali',
      field: 'HamaliTotal',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Cartage',
      exportHead: 'Cartage',
      field: 'CartageTotal',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    ...(loginCountryId !== 2
      ? [
        {
          headerName: 'GST',
          exportHead: 'GST',
          field: 'GstTotal',
          xlCol: { dataType: 'number', dataFormatter: null },
          isSortIcon: true,
        },
      ]
      : []),
    {
      headerName: loginCountryId === 2 ? 'Insurance' : 'Valuation',
      exportHead: loginCountryId === 2 ? 'Insurance' : 'Valuation',
      field: 'ValuationTotal',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Other \nCharges',
      exportHead: 'Other \nCharges',
      field: 'OtherChargeTotal',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
    {
      headerName: 'Total \nAmount',
      exportHead: 'Total \nAmount',
      field: 'TotalNetAmount',
      xlCol: { dataType: 'number', dataFormatter: null },
      isSortIcon: true,
    },
  ]
  if (UseToPayAsCOD === 1) {
    columns = columns.map((col) => {
      if (col.field === 'TopayFreight') {
        return { ...col, headerName: 'COD \nFreight', exportHead: 'COD \nFreight' };
      }
      return col;
    });
  }

  return columns;
};

export const vehicleAndTripWiseDispatchCols = [
  { id: 1, header: 'SN', exportHead: 'SN', field: 'SN', weight: 30, xlCol: xlCol, align: 'left', isSortIcon: false, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 2, header: 'Vehicle No', exportHead: 'Vehicle No', field: 'VehicleNo', weight: 30, xlCol: xlCol, align: 'left', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 3, header: 'Trip Name', exportHead: 'Trip Name', field: 'TripName', weight: 30, xlCol: xlCol, align: 'left', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 4, header: 'Trip Date-Time', exportHead: 'Trip Date-Time', field: 'ChartDate', weight: 30, xlCol: xlCol, align: 'left', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 5, header: 'Dis. Date', exportHead: 'Dis. Date', field: 'DispatchDateOnly', weight: 30, xlCol: xlCol, align: 'left', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 6, header: 'Dis. Time', exportHead: 'Dis. Time', field: 'DispatchTime', weight: 30, xlCol: xlCol, align: 'left', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 7, header: 'NOP', exportHead: 'NOP', field: 'NOP', weight: 30, xlCol: xlColq, align: 'right', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 8, header: 'Freight KMW', exportHead: 'Freight KMW', field: 'FreightKMS', weight: 30, xlCol: xlColq, align: 'right', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
  { id: 9, header: 'Freight Actual', exportHead: 'Freight Actual', field: 'Freight', weight: 30, xlCol: xlColq, align: 'right', isSortIcon: true, isSelected: false, isDefault: false, isMandatory: false, },
  { id: 10, header: 'Other Charges', exportHead: 'Other Charges', field: 'OtherCharges', weight: 30, xlCol: xlColq, align: 'right', isSortIcon: true, isSelected: false, isDefault: false, isMandatory: false, },
  { id: 11, header: 'Net Amount', exportHead: 'Net Amount', field: 'NetAmount', weight: 30, xlCol: xlColq, align: 'right', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, },
]

const splitDispatchDateTime = (dispatchDateTime) => {
  const dateTime = moment(dispatchDateTime, ['DD-MMM-YY hh:mm A', 'DD-MMM-YY HH:mm A', moment.ISO_8601], true)

  if (!dispatchDateTime || !dateTime.isValid()) {
    return { DispatchDateOnly: '', DispatchTime: '' }
  }

  return {
    DispatchDateOnly: dateTime.format('DD-MMM-YY'),
    DispatchTime: dateTime.format('hh:mm A'),
  }
}

export const prepareVehicleWiseData = (data, columns) => {
  const grouped = {}

  data.forEach(row => {
    const vehicleNo = row.VehicleNo || ''
    const tripName = row.TripName || ''
    const chartDate = row.ChartDate || ''
    const { DispatchDateOnly, DispatchTime } = splitDispatchDateTime(row.DispatchDate || row.DispatchDateTime)
    const key = `${vehicleNo}_${tripName}_${chartDate}`
    if (!grouped[key]) {
      grouped[key] = {
        VehicleNo: vehicleNo,
        TripName: tripName,
        ChartDate: chartDate,
        DispatchDateOnly,
        DispatchTime,
        NOP: 0,
        FreightKMS: 0,
        Freight: 0,
        OtherCharges: 0,
        NetAmount: 0,
      }
    }
    grouped[key].NOP += Number(row.NOP) || 0
    grouped[key].FreightKMS += Number(row.FreightKMS) || 0
    grouped[key].Freight += Number(row.Freight) || 0
    grouped[key].OtherCharges += Number(row.OtherCharges) || 0
    grouped[key].NetAmount += Number(row.NetAmount) || 0
  })
  const groupedArray = Object.values(grouped).map((item, index) => ({
    ...item,
    SN: index + 1,
    dataType: 'entry'
  }))
  const totalRow = { dataType: 'total', isTotal: true }
  columns.forEach(col => {
    const key = col.field
    if (col.xlCol === xlColq) {
      totalRow[key] = groupedArray.reduce((sum, row) => {
        return sum + (parseFloat(row[key]) || 0)
      }, 0)
    } else {
      totalRow[key] = key === 'VehicleNo' ? 'Total' : ''
    }
  })
  return [...groupedArray, totalRow]
}
export const tabSx = {
  minHeight: '30px',
  height: '35px',
  flex: 1,
  maxWidth: '150px',
  padding: '5px 12px',
  position: 'relative',

  '&.Mui-selected::after': {
    content: '""',
    position: 'absolute',

    left: '6px',    
    right: '6px',    

    bottom: '0px',
    height: '4px',
    backgroundColor: '#0086ff',
  },
}
